import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../../redux";
import { GridItem } from "./styled";
import { PostItem } from "./post-item";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import { Story } from "@radivision/graphql/lib/ts/graphql/story";

import { SVG } from "../../../../component-configuration/svgs";

interface ComponentProps {
  subject: Person | Entity;
}

interface MapDispatchProps {}
interface MapStateProps {}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;
const PAGE_SIZE = 8;
const PostsGridComponent = (props: Props) => {
  const { subject } = props;

  const [page, setPage] = React.useState(1);

  const posts = subject?.mediaAbout?.edges?.map((edge: any) => edge.story);

  const MoreBreakLine = React.useCallback(() => {
    const total = posts?.length;
    const thereIsMore = total > page * PAGE_SIZE;
    if (!thereIsMore) return null;
    return (
      <div className="more-line-break" onClick={() => setPage(page + 1)}>
        <div className="br" />
        <span>
          <em>{SVG.chevronDown}</em>
        </span>
        <div className="br" />
      </div>
    );
  }, [page, setPage, posts]);

  return (
    <>
      <div className="posts-grid">
        {posts &&
          posts.map((item: Story) => (
            <GridItem key={item.id}>
              <PostItem item={item} key={`${item.id}`} subject={subject} />
            </GridItem>
          ))}
      </div>
    </>
  );
};

const mapState = (state: AppState) => ({});

const mapDispatch = {};

export const PostsGrid = connect(mapState, mapDispatch)(PostsGridComponent);
